import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown";
import { Button } from "@/components/ui/button";
import { Edit3, Mail, MoreHorizontal } from "lucide-react";

interface IProp {
  id: string;

  onOpenView?: () => void;
  onOpenEdit?: () => void;
  onOpenDelete?: () => void;
  setTransactionId: (v: string) => void;
  setMerchant: () => void;
}
const Options = ({
  id,
  onOpenView,
  onOpenEdit,
  onOpenDelete,
  setTransactionId,
  setMerchant,
}: IProp) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="space-y-2 rounded-[10px] p-2" align="end">
        <DropdownMenuItem
          onClick={() => {
            onOpenView?.();
            setMerchant();
          }}
          className="flex items-center gap-2 rounded-md bg-[#5B93FF] bg-opacity-5 p-2 text-[#5B93FF]"
        >
          <Edit3 size={16} />
          <span>View Merchant Details</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            onOpenEdit?.();
            setMerchant();
          }}
          className="flex items-center gap-2 rounded-md bg-[#46ea7d] bg-opacity-5 p-2 text-[#46ea7d]"
        >
          <Mail size={16} />
          <span>Edit Merchant</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={() => {
            onOpenDelete?.();
            setMerchant();
          }}
          className="flex items-center gap-2 rounded-md bg-[#ea4654] bg-opacity-5 p-2 text-[#ea4654]"
        >
          <Mail size={16} />
          <span>Delete Merchant</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Options;
